import { z } from 'zod';
import { formatAddress, AddressSchema } from '@/modules/location/domain/AddressSchema.ts';
import { filteredJoin } from '@/modules/location/domain/filteredJoin.ts';

export const CoordinatesSchema = z.object({
    latitude: z.number(),
    longitude: z.number(),
    openLocationCode: z.string(),
});
export type Coordinates = z.infer<typeof CoordinatesSchema>;

export const GeoAddressSchema = z.object({
    address: AddressSchema,
    coordinates: CoordinatesSchema,
});
export type GeoAddress = z.infer<typeof GeoAddressSchema>;

export const format = (geoAddress: GeoAddress) => {
    return filteredJoin([formatAddress(geoAddress.address), geoAddress.coordinates.openLocationCode], ', ');
};
